import {Component, Input} from '@angular/core';
import * as moment from 'moment';
import {CommandsService} from '@app/app/shared/services/commands.service';

@Component({
  templateUrl: './park-tasks-item.html',
  selector: 'park-tasks-item'
})
export class ParkTasksItemComponent {
  @Input() task: any;
  @Input() parkId: any;
  @Input() taskId: any;
  @Input() id: any;

  constructor(private comm: CommandsService) {
  }

  markTaskAsDone() {
    const params = {
      mark: {
        task_id: this.taskId
      }
    };

    this.comm.createOrEditTask(this.parkId, this.id, params).then((res) => {
      //
    }).catch(() => {
      //
    });
  }

  dueDate(date: string) {
    const parsedDate = moment(date, 'YYYY-MM-DD');
    return parsedDate.isValid() ? parsedDate.format('MMM Do YYYY') : '';
  }
}



// WEBPACK FOOTER //
// ./src/app/dashboard/parks/park/tasks/park-tasks-item/park-tasks-item.component.ts